import {
  IStandardAPIResponse,
  ISearchAcc,
  IAirCooledChillerReading,
  IWaterCooledChillerReading,
  IReadingStatus,
} from "../../vm";
import { httpClient, handleErrorResp } from "../UtilService";

//AIR
export async function getAccReadings(
  obj: ISearchAcc
): Promise<IStandardAPIResponse<Array<any>>> {
  try {
    let res = await httpClient<Array<any>>(
      `cooled-chiller-readings`,
      "GET",
      obj
    );
    return res;
  } catch (err) {
    return handleErrorResp([]);
  }
}

export async function updateAccReadingStatus(
  obj: IReadingStatus
): Promise<IStandardAPIResponse<any>> {
  try {
    let res = await httpClient<any>(
      `air-cooled-chiller-readings/status`,
      "PATCH",
      obj
    );
    return res;
  } catch (err) {
    return handleErrorResp([]);
  }
}

export async function updateAccReading(
  data: IAirCooledChillerReading
): Promise<IStandardAPIResponse<IAirCooledChillerReading>> {
  try {
    let res = await httpClient<IAirCooledChillerReading>(
      `air-cooled-chiller-readings/${data._id}`,
      "PATCH",
      data
    );
    return res;
  } catch (err) {
    return handleErrorResp([]);
  }
}

//WATER
// export async function getWccReadings(
//   obj: ISearchAcc
// ): Promise<IStandardAPIResponse<Array<IWaterCooledChillerReading>>> {
//   try {
//     let res = await httpClient<Array<IWaterCooledChillerReading>>(
//       `water-cooled-chiller-readings`,
//       "GET",
//       obj
//     );
//     return res;
//   } catch (err) {
//     return handleErrorResp([]);
//   }
// }

export async function updateWccReadingStatus(
  obj: IReadingStatus
): Promise<IStandardAPIResponse<any>> {
  try {
    let res = await httpClient<any>(
      `water-cooled-chiller-readings/status`,
      "PATCH",
      obj
    );
    return res;
  } catch (err) {
    return handleErrorResp([]);
  }
}

export async function updateWccReading(
  data: IWaterCooledChillerReading
): Promise<IStandardAPIResponse<IWaterCooledChillerReading>> {
  try {
    let res = await httpClient<IWaterCooledChillerReading>(
      `water-cooled-chiller-readings/${data._id}`,
      "PATCH",
      data
    );
    return res;
  } catch (err) {
    return handleErrorResp([]);
  }
}
